import { render } from "./OCRComponent.vue?vue&type=template&id=3dfc823c&scoped=true"
import script from "./OCRComponent.vue?vue&type=script&lang=js"
export * from "./OCRComponent.vue?vue&type=script&lang=js"

import "./OCRComponent.vue?vue&type=style&index=0&id=3dfc823c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfc823c"]])

export default __exports__